import PropTypes from 'prop-types';

import { header, headerTick } from './styles.module.scss';

export const TextHeader = ({ type, children, icon, ...other }) => {
  const ElementType = type;
  const classes = icon === 'tick' ? headerTick : header;
  return (
    <ElementType className={classes} {...other}>
      {children}
    </ElementType>
  );
};

TextHeader.propTypes = {
  type: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
  children: PropTypes.string.isRequired,
  icon: PropTypes.oneOf(['tick'])
};

TextHeader.defaultProps = {
  type: 'h1'
};
